import { Grid } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import RouteKey from "../utils/RouteKey";
import GstInvoiceFlowApp2 from "../pages/App2-GSTPaymentsSimplified";


const AppRoute = () => {
  return (
    <Grid container columnSpacing={1}>
      <Grid
        component="main"
        className="mainComponent"
        // Custom css
        sx={{
          flex: 4,
          boxSizing: "border-box",
          margin: {
            xl: "calc(2rem) 2%",
            md: "calc(2rem) 3%",
            xs: "calc(2rem) 4%",
          },
          maxHeight: "100vh",
        }}
        minWidth={0}
      >
        <Routes>
         {/* <Route
              path="/"
              element={<Navigate to={RouteKey.KEY_GST_PAYMENT_SIMPLIFIED} replace />}
          />*/}
          <Route
            path={`${RouteKey.KEY_GST_PAYMENT_SIMPLIFIED}`}
            element={<GstInvoiceFlowApp2 />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Grid>
    </Grid>
  );
};
export default AppRoute;

function NotFound() {
  return (
      <div>
        <h1>404</h1>
        <p>Page not found</p>
      </div>
  );
}